import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'bulkReportsDownload'

export default ({ campaignId, fileName }) => (asyncAction(
  name,
  ReportsService.bulkReportsDownload,
  { campaignId, fileName }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/bulkReportsDownload.js